// i18n area 'system' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/system.sr-Latn-RS.meta.json.
import type { enUS } from './system'

export const srLatnRS: typeof enUS = {
  diagnostics: {
    title: 'Dijagnostika',
    subtitle: 'Šta ne valja, najgore prvo — isto sočivo kao tvirt diagnose',
    reload: 'Ponovo učitaj',
    loadError: 'Dijagnozu nije bilo moguće pročitati',
    exportBundle: 'Izvezi paket',
    exportError: 'Paket nije bilo moguće napraviti',
    noProblem: 'Nema problema u pregledanim oblastima',
    nothingInspected: 'NIŠTA nije pregledano — ovo nije potvrda dobrog zdravlja',
    inspected: 'Pregledane',
    notInspected: 'NISU pregledane',
    localHint: 'Lokalne oblasti čvora (systemd jedinice, journal) čitaju se samo iz CLI-ja: tvirt diagnose --area local — put kad API ne odgovara.',
    thresholds: 'neuspeli zadaci u okviru {hours} h, heartbeat kasni više od {seconds} s',
    severity: {
      critical: 'Kritično',
      warning: 'Upozorenje',
      unknown: 'Nepoznato'
    }
  },
  explorer: {
    title: 'Istraživač resursa',
    root: 'Koren',
    empty: 'Nijedan resurs u ovom scopeu',
    previewHint: 'Izaberite objekat da biste videli pregled',
    open: 'Otvori',

    // Il deep-link ?scope= delle liste CRUD (round #109), dall'esplora (#143).
    openScoped: 'Otvori listu u ovom scopeu',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM šablon',
      ct: 'CT',
      ctTemplate: 'CT šablon',
      app: 'Aplikacija',
      overlayNetwork: 'Overlay mreža',
      networkService: 'Mrežni servis',
      fabric: 'Fabric',
      subnet: 'Podmreža',
      storage: 'Storage pool',
      disk: 'Disk',
      catalogFile: 'Datoteka kataloga',
      ociRegistry: 'OCI registry',
      ociImage: 'OCI slika',
      cephCluster: 'Ceph klaster',
      backupDestination: 'Odredište bekapa',
      user: 'Korisnik',
      group: 'Grupa',
      role: 'Uloga',
      credential: 'Akreditiv',
      tag: 'Tag',
      proximityRule: 'Pravilo blizine'
    }
  },
  tags: {
    title: 'Tagovi',
    empty: 'Nema tagova',
    add: 'Dodaj tag',
    remove: 'Ukloni',
    name: 'Tag',
    value: 'Vrednost',
    save: 'Sačuvaj',
    saveError: 'Nije moguće sačuvati tagove',
    loadError: 'Nije moguće učitati rečnik tagova',
    noVocabulary: 'Nijedan tag nije dostupan za ovaj tip resursa',

    // A single-valued tag already set answers 409: the replacement is always
    // explicit — never an implicit substitution (design, ratified 2026-07-27).
    overwrite: 'Zameni trenutnu vrednost',

    // Sistema > Tag, the vocabulary surface.
    createTitle: 'Kreirajte tag',
    editTitle: 'Izmenite tag',
    nameHint: 'Slova, cifre, tačke, crtice i donje crte — bez ":" i bez "/"; prefiks tvirt- rezervisan je za platformu',
    cardinality: 'Kardinalnost',
    cardinalitySingle: 'Jedna vrednost',
    cardinalityMultiple: 'Više vrednosti',
    cardinalityHint: 'Sa jednom vrednošću, ponovna dodela taga traži da se vrednost zameni',
    autoCreate: 'Automatsko kreiranje vrednosti',
    autoCreateOn: 'Pri dodeli',
    autoCreateOff: 'Samo deklarisane',
    autoCreateHint: 'Uključeno: dodela nove vrednosti je kreira. Isključeno: dodeljuju se samo deklarisane vrednosti',
    values: 'Vrednosti',
    noValues: 'Nijedna vrednost nije deklarisana',
    addValue: 'Dodaj vrednost',
    duplicateValue: 'Duplirana vrednost',
    kinds: 'Tipovi resursa',
    kindsAll: 'Sve',
    kindsPlaceholder: 'Sve',
    kindsHint: 'Ostavite prazno da biste dozvolili svaki tip resursa koji se može tagovati',
    systemChip: 'Sistem',
    deleteCascade: 'Ukloni i dodeljivanja',
    deleteCascadeHint: 'Oznaka koja je još dodeljena nekom resursu se odbija: sa ovom opcijom vrednosti i sva dodeljivanja odlaze zajedno sa oznakom.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Kreirajte scope',
    editTitle: 'Preimenujte scope',
    path: 'Putanja',
    segment: 'Segment',
    segmentHint: 'Mala slova, cifre i crtice (DNS-1123)',
    parent: 'Roditelj',
    rootChip: 'Koren',
    preview: 'Novi scope',
    pickLabel: 'Scope',
    pickHint: 'Gde objekat živi u stablu klastera — koren ili vDC unutar njega.',
    ociCache: 'OCI cache (override)',
    appEphemeral: 'Efemerni pool za App (override)',
    inherit: 'Nasleđuje',
    inheritsFrom: 'Nasleđuje od',
    inheritsCluster: 'Nasleđuje podrazumevano za klaster',
    inheritsNone: 'Nasleđuje — nema efektivnog poola',
    failoverProtection: 'Zaštita pri degradaciji',
    networkWeight: 'Mrežna težina',
    networkCeil: 'Mrežni plafon (Mbps)',
    protectionProtected: 'Zaštićen',
    protectionExpendable: 'Potrošiv pri degradaciji',
    protectionDefault: 'Podrazumevano za klaster'
  },

  // Sistema > Informazioni (round #124, 2026-07-31): versioni piattaforma
  // nella flotta (al massimo due mid-upgrade), componenti per nodo, manuale
  // PDF servito localmente e card licenza inglobata.
  sysinfo: {
    summary: 'Verzije platforme u klasteru, komponente svakog čvora, administratorski priručnik i licenca.',
    platformTitle: 'TVirt platforma',
    platformSubtitle: 'Verzije posmatrane na čvorovima klastera',
    versionOnNodes: '{version} — čvorova: {n}',
    versionOnOneNode: '{version} na 1 čvoru',
    mixedVersions: 'Više od jedne verzije platforme u klasteru — očekivano samo dok je nadogradnja u toku (najviše dve).',
    tooManyVersions: 'Više od dve verzije platforme u klasteru — to se ne očekuje nikada, čak ni tokom nadogradnje: proverite čvorove ispod.',
    unreportedNodes: 'Još nema izveštaja o verzijama od: {nodes}',
    noVersionsYet: 'Nijedan čvor još nije prijavio svoje verzije.',
    nodesUnavailable: 'Lista čvorova nije vidljiva sa vašim dozvolama — verzije platforme nije moguće prikazati.',
    colNode: 'Čvor',
    manualTitle: 'Administratorski priručnik',
    manualSubtitle: 'Lokalna kopija, koju služi ovaj klaster',
    manualBody: 'Kompletan TVirt priručnik u PDF-u, koji platforma služi direktno — dostupan i u air-gapped okruženjima.',
    manualLink: 'Administratorski priručnik (PDF)',
    apiExplorerTitle: 'API pregledač',
    apiExplorerSubtitle: 'OpenAPI ugovor, dostupan za pregled',
    apiExplorerBody: 'Kompletan OpenAPI ugovor platforme — svaka ruta, šema i kod odgovora — dostupan za pregled iz pregledača, poslužen kroz ovaj čvor.',
    apiExplorerLink: 'Istraži API',
    kubeTitle: 'Kompatibilnost sa Kubernetesom',
    kubeSubtitle: 'kubectl i njegovi alati, ispred nativnog API-ja',
    kubeBody: 'TVirt KubeCompat projektuje Podove, Deploymente, Servise, namespace-ove, čvorove i događaje u Kubernetes dijalekt — samo za čitanje, plus brisanje Deploymenata. Svaki poziv prolazi kroz nativni API sa tvojim dozvolama: u kubeconfig-u koristi app token kao bearer.',
    kubeEndpoint: 'Endpoint za kubectl',
    kubeStatusActive: 'Aktivan — Kubernetes {version}',
    kubeStatusMissing: 'Nije instaliran na ovom čvoru (paket trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Instaliran, ali ne odgovara — proveri jedinicu trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Provera…'
  },

  // Licensing (round 2026-07-29): la pagina della licenza a sottoscrizione.
  licensing: {
    title: 'Licenca klastera',
    subtitle: 'Licenca po pretplati — najviše jedna po klasteru',
    absentTitle: 'Nijedna licenca nije registrovana',
    absentBody:
      'Bez važeće licence klaster odbija da pokreće nove virtuelne mašine (upaljeni VM-ovi ostaju upaljeni). Registrujte product key koji ste dobili uz pretplatu.',
    registerButton: 'Registruj licencu',
    removeButton: 'Ukloni licencu',
    state: {
      ok: 'Važeća',
      limitExceeded: 'Limit prekoračen',
      expired: 'Istekla'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Osnova limita',
    basis: {
      concurrentVms: 'Istovremeno upaljeni VM-ovi',
      physicalCores: 'Fizička jezgra (ukupno za klaster)'
    },
    limitLabel: 'Limit',
    usageLabel: 'Trenutna upotreba',
    usageOf: '{used} od {limit}',
    usagePartial: 'delimičan zbir — čvorova bez posmatrane CPU topologije: {n}',
    usageUnknown: 'trenutno se ne može očitati',
    expiresLabel: 'Istek',
    neverExpires: 'nikada',
    registeredLabel: 'Registrovana',
    gateNote:
      'Sa odsutnom, isteklom ili prekoračenom licencom klaster odbija da pokreće NOVE virtuelne mašine. Upaljeni VM-ovi ostaju upaljeni, a HA restartovanja nisu pogođena.',
    devStage:
      'Razvojna faza: product key se prihvata takav kakav je, zajedno sa ovde deklarisanim limitima; validacija potpisanim ključem stiže u budućem izdanju.',
    dialogTitle: 'Registrujte licencu',
    dialogExpiresHelp: 'Prazno = licenca nikada ne ističe',
    dialogSubmit: 'Registruj',
    dialogError: 'Nije moguće registrovati licencu.',
    removeTitle: 'Uklonite licencu',
    removeBody:
      'Klaster će ostati BEZ LICENCE: nove virtuelne mašine će odbijati da se pokrenu dok se jedna ne registruje. Upaljeni VM-ovi ostaju upaljeni.',
    removeConfirm: 'Ukloni',
    removeError: 'Nije moguće ukloniti licencu.'
  },
  rbac: {
    tabRoles: 'Uloge',
    tabGrants: 'Dodele',
    rolesTitle: 'Uloge',
    createRoleTitle: 'Kreirajte ulogu',
    editRoleTitle: 'Izmenite ulogu',
    nameHint: 'Mala slova, cifre i crtice; prefiks tvirt- je rezervisan',
    systemChip: 'Sistem',
    permissions: 'Dozvole',
    permissionsPlaceholder: 'Dodajte dozvolu…',
    includedRoles: 'Uključene uloge',
    includedRolesPlaceholder: 'Dodajte ulogu…',
    grantsTitle: 'Dodele',
    createGrantTitle: 'Kreirajte dodelu',
    principal: 'Principal',
    principalKind: 'Tip principala',
    principalUser: 'Korisnik',
    principalGroup: 'Grupa',
    role: 'Uloga',
    grantRight: 'Delegiranje',
    grantRightChip: 'Može da delegira',
    grantRightLabel: 'Sa pravom delegiranja (primalac može ovu ulogu dalje da delegira)',
    effective: 'Efektivna',
    notEffective: 'Nije efektivna',
    createdAt: 'Kreirana',
    scopeHint: '/path tačno, /path/* rekurzivno — dodele se sidre na montirani koren (/* nije moguće dodeliti)'
  },
  groups: {
    title: 'Grupe',
    createTitle: 'Kreirajte grupu',
    nameHint: 'Mala slova, cifre i crtice; jedinstveno unutar scopea',
    members: 'Članovi',
    membersTitle: 'Članovi',
    membersPlaceholder: 'Dodajte korisnika…',
    noMembers: 'Nema članova',
    realmMappings: 'Realm mapiranja',
    realmMappingsTitle: 'Realm mapiranja',
    realmMappingsHint:
      'Čemu ova grupa odgovara u svakom spoljnom realmu. Članstvo se čita iz direktorijuma pri prijavi: grupa iz direktorijuma koju niko ovde ne mapira ignoriše se, a ugnežđivanje se ne razrešava — izravnajte ga na strani direktorijuma.',
    realm: 'Realm',
    externalGroup: 'Spoljna grupa',
    addRealmMapping: 'Dodaj mapiranje',
    removeRealmMapping: 'Ukloni mapiranje',
    noRealmMappings: 'Nema realm mapiranja',

    // Dialog di creazione a sezioni (round realm-wizard, 2026-08-03): Generale
    // più la superficie di mappatura coi realm esterni, con l'empty state
    // parlante.
    sectionGeneral: 'Opšte',
    mappingsNoRealms: 'Nijedan spoljni realm nije konfigurisan — površina za mapiranje se otključava čim realm postoji.',
    mappingsNoRealmsLink: 'Otvori tab Realmovi i SSO',

    // L'obbligo MFA imposto dal gruppo (round #178 metà B): OR puro — un
    // gruppo può solo AGGIUNGERE l'obbligo, mai toglierlo.
    mfaRequired: 'MFA obaveza',
    mfaRequiredChip: 'Nameće MFA',
    mfaNotRequiredChip: 'Bez obaveze',
    mfaRequiredHint:
      'Čist OR: grupa može da DODA obavezu drugog faktora svojim članovima — i spoljnim identitetima, kroz svoja realm mapiranja — ali nikada da je ukine. Važi od sledeće prijave: otvorene sesije se ne zatvaraju.'
  },
  users: {
    title: 'Korisnici',
    createTitle: 'Kreirajte korisnika',
    editTitle: 'Izmenite korisnika',
    username: 'Korisničko ime',
    usernameHint: 'Mala slova, cifre, tačke i crtice',
    displayName: 'Prikazano ime',
    enabled: 'Omogućen',
    state: 'Stanje',
    enabledChip: 'Omogućen',
    disabledChip: 'Onemogućen',
    lockedChip: 'Zaključan',
    password: 'Lozinka',
    passwordSetChip: 'Postavljena',
    mustChangeChip: 'Mora se promeniti',
    initialPassword: 'Početna lozinka',
    initialPasswordHint: 'Korisnik mora da je promeni pri prvoj prijavi',
    lastLogin: 'Poslednja prijava',
    neverLoggedIn: 'Nikada se nije prijavio',
    setPasswordTitle: 'Postavite lozinku',
    setPasswordHint: 'Administrativna zamena — zahteva vašu lozinku (sudo režim) i obavezuje korisnika da je promeni pri sledećoj prijavi.',
    operatorPassword: 'Vaša lozinka',
    unlock: 'Otključaj nalog',
    revokeTitle: 'Opozovite sesije',
    revokeBody: 'Sve aktivne sesije ovog korisnika odmah se prekidaju.',
    revokeIncludeTokens: 'Opozovi i app tokene',
    revokeConfirm: 'Opozovi',

    // Dialog standard (round #156): dettagli completi, tab account/sicurezza.
    tabAccount: 'Nalog',
    tabSecurity: 'Bezbednost',
    usernameImmutableHint: 'Korisničko ime je identitet naloga — fiksirano pri kreiranju',
    groups: 'Grupe',
    noGroups: 'Nema grupa',
    mustChangePassword: 'Obavezna promena lozinke',
    failedAttempts: 'Neuspešni pokušaji prijave',
    lockedUntil: 'Zaključan do',

    // Identity tabs (2026-08-03): Sistema > Utenti è diventata una sezione a
    // tab sul modello di /system/rbac — utenti, gruppi, realm esterni.
    tabUsers: 'Korisnici',
    tabGroups: 'Grupe',
    tabRealms: 'Realmovi i SSO',
    tabMfa: 'MFA',

    // Tab MFA (task #178): la vista del secondo fattore. Metà A — la tabella
    // per-utente su users.yaml; metà B (round contract, ratifiche 2026-08-04)
    // — il verdetto efficace con la provenienza, gli enrollment esterni con
    // lo stato orfano e i gruppi che impongono l'obbligo.
    mfa: {
      title: 'Drugi faktor (MFA)',
      methodsTitle: 'Dostupne metode',
      methodsSubtitle: 'Ono što ova instalacija ume da verifikuje kao drugi faktor',
      methodsError: 'Nije moguće učitati registar metoda',
      builtinChip: 'Ugrađen',
      enrollableChip: 'Enrollment u TVirt-u',
      delegatedChip: 'Upravljan spolja',
      state: 'Stanje',
      stateActive: 'Aktivan',
      statePending: 'Čeka enrollment',
      stateNone: 'Bez enrollmenta',
      required: 'MFA obaveza',
      requiredChip: 'Obavezan',
      notRequiredChip: 'Nije obavezan',
      enrolledAt: 'Enrollment od',
      enrolledMethods: 'Upisane metode',
      noMethods: 'Nema enrollmenta',
      codesRemaining: 'Preostali kodovi za oporavak',
      resetTitle: 'Resetujte drugi faktor',
      resetHint:
        'Enrollment i svi kodovi za oporavak se brišu: pri sledećoj prijavi korisnik prolazi enrollment iznova, od nule. MFA obaveza ostaje kakva jeste — administrator nikada ne postavlja tajnu, samo je briše.',
      resetConfirm: 'Resetuj',
      resetError: 'Nije moguće resetovati drugi faktor',
      empty: 'Još nema nijednog upravljanog korisnika — nalozi se pojavljuju ovde čim postoje, svaki sa svojim stanjem drugog faktora.',

      // Metà B (round #178): provenienza del verdetto efficace, enrollment
      // esterni con lo stato orfano, gruppi che impongono l'obbligo.
      viaSelf: 'Lično',
      viaSelfHint: 'Lični doprinos naloga (njegov flag) — jedini deo koji olovka menja.',
      viaGroupHint: 'Obaveza nasleđena od ove grupe: uklanjanje ličnog flaga ne oslobađa korisnika — deluje se na grupu, u tabu Grupe.',
      subject: 'Identitet',
      lastSeenAt: 'Poslednja potvrda',
      enrollmentPending: 'Na čekanju',
      orphanChip: 'Siroče',
      orphanDirectoryMiss: 'Identitet više nije u direktorijumu',
      orphanRealmRemoved: 'Realm je uklonjen iz TVirt-a',
      orphanedAt: 'Siroče od',
      directoryUuid: 'UUID u direktorijumu',
      externalTitle: 'Spoljni enrollmenti',
      externalEmpty: 'Još nema spoljnih enrollmenta — nastaje pri prvoj prijavi identiteta iz direktorijuma pod MFA obavezom.',
      orphanHelp:
        'Osiroteli enrollment nikada se ne briše sam od sebe: to je bezbednosni materijal — ostaje zbog audita i, ako se identitet ponovo pojavi u direktorijumu, ponovo nalazi svoj faktor. Jedini izlaz je administrativni reset.',
      visibilityHint: 'Spoljni enrollmenti žive u korenu klastera: vidi ih samo onaj ko ima user.read nad celim stablom.',
      orphanResetHint:
        'Osiroteli red uklanja se zauvek: niko ga više ne potražuje. Ako se identitet ikada vrati u direktorijum, proći će enrollment iznova, od nule.',
      enforcingTitle: 'Grupe koje nameću MFA',
      enforcingSubtitle:
        'Sidro obaveze za spoljne identitete je grupa: njena realm mapiranja kažu do koje populacije direktorijuma dopire. Spoljni enrollment nastaje pri prvoj prijavi obavezanog korisnika.',
      enforcingEmpty: 'Nijedna grupa ne nameće MFA — obaveza se uključuje na grupi, iz taba Grupe.',
      enforcingError: 'Nije moguće učitati grupe koje nameću MFA'
    }
  },
  realms: {
    title: 'Realmovi za autentifikaciju',
    createTitle: 'Kreirajte realm',
    editTitle: 'Izmenite realm',
    name: 'Realm',
    nameHint: 'Domen koji korisnici kucaju posle @ (example.com) — nepromenljiv nakon kreiranja',
    nameImmutableHint: 'Ime realma utisnuto je u svaku sesiju i svaki red audita koji ga je ikada imenovao — preimenovanje bi prepisalo istoriju',
    kind: 'Tip',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC i SAML stižu u narednim rundama — danas je realm LDAPv3 direktorijum',

    // Semi-wizard di creazione (round realm-wizard, 2026-08-03): le card dei
    // tipi del passo 1 — ldap vivo, oidc/saml card in roadmap (mai un form
    // senza un backend dietro).
    kindCategory: 'Tip realma',
    kindSelectHint: 'Izaberite tip direktorijuma nad kojim će ovaj realm da autentifikuje.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Korisničko ime i lozinka provereni bindom na LDAPv3 direktorijumu — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on iz browsera delegiran OpenID Connect identity provideru — stiže u narednim rundama.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Poslovni single sign-on sa SAML 2.0 asercijama — stiže u narednim rundama.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Omogućen',
    urls: 'Serveri direktorijuma',
    urlsHint: 'Jedan ldap:// ili ldaps:// URL u svakom redu (1–8), probaju se redom — failover, nikada balansiranje',
    startTls: 'StartTLS',
    verifyCertificate: 'Proveri sertifikat',
    cleartextWarning: 'Bez ldaps:// ili StartTLS-a bind lozinka prelazi mrežu u čistom tekstu — prihvatljivo u laboratoriji, nikada u produkciji.',
    noVerifyWarning: 'Neproverena TLS sesija ne autentifikuje nikoga: isključite proveru samo prema direktorijumu koji ne možete popraviti.',
    caCertificate: 'CA sertifikat (PEM)',
    caCertificateHint: 'Opcioni CA bundle pinovan za TLS/StartTLS handshake ovog realma; prazno ga uklanja',
    caCertificatePinned: 'Pinovan',
    connectTimeout: 'Timeout (sekunde)',
    connectTimeoutHint: 'Rok za konekciju i zahtev po URL-u (1–60); po isteku se proba sledeći URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Servisni nalog koji izvršava pretragu korisnika; prazno = anonimni search bind (AD ga odbija)',
    anonymousBind: 'Anonimni search bind',
    bindCredential: 'Bind lozinka (keystore)',
    bindCredentialHint: 'Jedan usernamePassword unos u keystoreu sa bind lozinkom — tajna nikada ne živi na realmu',
    bindCredentialNone: 'Nijedna (anonimni bind)',
    bindCredentialEmpty: 'Još nema usernamePassword unosa u keystoreu — kreirajte jedan u Sistem > Akreditivi za bind lozinku.',
    baseDn: 'Base DN',
    baseDnHint: 'Podstablo od kojeg kreće pretraga korisnika (DC=example,DC=com)',
    userFilter: 'Korisnički filter',
    userFilterHint: '%u se zamenjuje lokalnim delom prijave, uz RFC 4515 escape; ne-AD direktorijumi tipično traže (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf atribut',
    memberOfAttributeHint: 'Čita se samo jednom, pri prijavi — nemapirane grupe se ignorišu, ugnežđivanje se ne razrešava',
    uuidAttribute: 'UUID atribut',
    uuidAttributeHint: 'Nepromenljivi UUID unutar realma (objectGUID na AD-u, entryUUID na OpenLDAP-u) — utisnut u audit pored korisnik@realm',
    displayNameAttribute: 'Atribut prikazanog imena',
    displayNameAttributeHint: 'Koristi se za pozdrav korisniku; ako ga nema, koristi se ime za prijavu',
    sudoHint: 'Upisi na realmove su sudo-zaštićeni: realm je ulazna vrata u platformu',
    deleteBody: 'Mapiranja grupa realma odlaze sa njim; sesije koje je autentifikovao ostaju žive do isteka — obrisani realm prosto više ne prima nikoga novog.',
    tabConnection: 'Konekcija',
    tabDirectory: 'Direktorijum',
    testTitle: 'Test konekcije',
    testHint: 'Konfiguraciona sonda, nikada autentifikacija: povezuje se, radi bind servisnim nalogom i — sa korisničkim imenom — izvršava korisnički filter.',
    testUsername: 'Korisničko ime (opciono)',
    testUsernameHint: 'Lokalni deo nad kojim se izvršava korisnički filter — 1 pogodak je zdrav odgovor',
    testRun: 'Pokreni test',
    testError: 'Nije moguće pokrenuti sondu',
    testReachable: 'Direktorijum dostupan, servisni bind prihvaćen',
    testUnreachable: 'Direktorijum NIJE dostupan',
    matchedOne: 'Korisnički filter je našao tačno 1 unos — zdrav odgovor.',
    matchedNone: 'Korisnički filter nije našao nijedan unos: filter ili base DN je pogrešan.',
    matchedMany: 'Korisnički filter je našao više unosa ({count}): nije selektivan, pa bi prijave bile dvosmislene (odbijene).',
    mappingsPointer: 'Čemu spoljna grupa odgovara jeste svojstvo TVirt grupe (njena realm mapiranja): tačka istine živi u tabu Grupe.',
    mappingsPointerLink: 'Otvori tab Grupe',
    rootHomeHint: 'Identiteti spoljnog realma žive u korenu klastera, nikada u vDC-u: dozvole se dodeljuju tamo gde su potrebne, putem dodela — na grupi ili direktno na korisniku, baš kao i za domaće korisnike.'
  },
  credentials: {
    title: 'Akreditivi',
    createTitle: 'Kreirajte akreditiv',
    editTitle: 'Izmenite akreditiv',
    kind: 'Tip',
    kindUsernamePassword: 'Username i lozinka',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph identitet)',
    kindHintUsernamePassword: 'Nepromenljivo. Za CIFS/SMB storage — nalog za montiranje čiju tajnu worker koristi u trenutku montiranja.',
    kindHintIscsiChap: 'Nepromenljivo. Za iSCSI CHAP autentifikaciju — username = CHAP ime, secret = CHAP tajna.',
    kindHintNvmeDhchap: 'Nepromenljivo. Za DH-HMAC-CHAP na NVMe over Fabrics — secret = DHHC-1:xx:… blob; username je samo oznaka.',
    kindHintCephx: 'Nepromenljivo. Za Ceph klijente — username = ime klijenta (client.…), secret = base64 ključ.',
    kindImmutableHint: 'Tip je nepromenljiv nakon kreiranja — promena znači novi akreditiv.',
    username: 'Korisničko ime',
    usernameChap: 'CHAP ime',
    usernameNvme: 'Oznaka',
    usernameCephx: 'Ime klijenta',
    usernameHint: 'Opcioni nalog kojem tajna pripada',
    usernameHintChap: 'CHAP ime kojim se initiator autentifikuje',
    usernameHintNvme: 'Transport je ne koristi — slobodna oznaka za vašu evidenciju',
    usernameHintCephx: 'Ime cephx klijenta — prefiks client. se toleriše',
    secret: 'Tajna',
    secretHint: 'Samo za upis: koriste je konzumenti, nikada se više ne prikazuje.',
    secretHintNvmeDhchap: 'Samo za upis: host DH-HMAC-CHAP tajna u kanonskom obliku DHHC-1:xx:… — koriste je konzumenti, nikada se više ne prikazuje.',
    secretHintCephx: 'Samo za upis: base64 cephx ključ — koriste ga konzumenti, nikada se više ne prikazuje.',
    secretEditHint: 'Ostavite prazno da tajna ostane ista — popunjavanje je rotira.',
    createdAt: 'Kreiran',
    inUseError: "Na '{name}' se poziva konfiguracija nekog storagea — prvo ga tamo otkačite.",
    nameHint: 'Mala slova, cifre i crtice (DNS-1123); jedinstveno po scopeu',

    // Dialog di sola rotazione (round #156): il segreto non ha mai la matita inline.
    rotateTitle: 'Rotirajte tajnu',
    rotateHint: 'Samo za upis: nova tajna zamenjuje sačuvanu — konzumenti je preuzimaju pri sledećem montiranju.',

    // Round #159 (PKI): i tab Certificati e CA.
    tabSecrets: 'Tajne',
    tabCertificates: 'Sertifikati',
    tabAuthorities: 'Sertifikaciona tela',
    certificatesTitle: 'Sertifikati',
    authoritiesTitle: 'Sertifikaciona tela',
    caCreateTitle: 'Novi CA',
    certCreateTitle: 'Novi sertifikat',
    caMode: 'Izvor',
    caModeGenerate: 'Generiši sa TVirt-om',
    caModeImport: 'Uvezi (ključ + sertifikat)',
    certMode: 'Izvor',
    certModeIssue: 'Izdaj od CA iz keystorea',
    certModeImport: 'Uvezi (ključ + sertifikat)',
    issuingCa: 'CA izdavalac',
    issuingCaHint: 'Sertifikat nastaje u scopeu tog CA, sa zabeleženim parentom',
    noCasHint: 'Još nema nijednog CA u keystoreu — prvo generišite ili uvezite jedan u tabu CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject tog CA: slova, cifre, razmak, tačka, donja crta, crtica',
    commonNameCertHint: 'OpenVPN identifikuje klijente po CN-u — držite ga jedinstvenim unutar CA',
    days: 'Važenje (dana)',
    daysCaHint: '1–7300 dana; 3650 (10 godina) je podrazumevano',
    daysCertHint: '1–3650 dana; 365 je podrazumevano',
    keyType: 'Tip ključa',
    keyTypeHint: 'EC P-256 je podrazumevan; RSA za legacy konzumente',
    usage: 'Namena',
    usageClient: 'Klijent (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Extended key usage za koji se sertifikat izdaje',
    san: 'Alternativna imena (SAN)',
    sanHint: 'Odvojena zarezom; IP literali postaju IP: unosi, ostalo DNS:',
    keyPem: 'Privatni ključ (PEM)',
    keyPemHint: 'Samo za upis: čuva se u keystoreu, nikada se više ne prikazuje',
    certPem: 'Sertifikat (PEM)',
    certPemHint: 'Javni sertifikat koji se uparuje sa ključem',
    certPemCaHint: 'CA sertifikat koji se uparuje sa ključem (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Izdavalac',
    parentCa: 'CA izdavalac',
    parentCaImported: 'Uvezen — izdat van TVirt-a',
    serial: 'Serijski broj',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Važi od',
    validUntil: 'Važi do',
    expiry: 'Istek',
    expired: 'Istekao',
    expiresInDays: 'Ističe za {days} d',
    revoked: 'Opozvan',
    revokedAtLabel: 'Opozvan dana',
    revokeTitle: 'Opozovite sertifikat',
    revokeAction: 'Opozovi',
    revokeWarning: 'Opoziv je konačan: serijski broj ulazi u CRL CA izdavaoca i svaki konzument koji odbija opozvane sertifikate (OpenVPN pre svih) odbaciće ovaj. Ne postoji un-revoke.',
    exportPem: 'Izvezi PEM',
    exportChain: 'Izvezi bundle lanca',
    exportCrl: 'Izvezi CRL',
    materialImmutableHint: 'X.509 materijal je nepromenljiv — ponovo izdajte ili ponovo uvezite',
    caInUseError: "'{name}' još ima žive izdate sertifikate (ili se neki storage poziva na njega) — prvo ih opozovite ili obrišite."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Raspoređivanje, dostupnost i afinitet — gde rade VM-ovi klastera i da li treba da budu upaljeni',
    loadError: 'Proximity panelu je potreban store klastera — stanje flote trenutno nije dostupno',
    config: {
      title: 'Konfiguracija',
      subtitle: 'Politika raspoređivanja na nivou klastera',
      save: 'Sačuvaj',
      saveError: 'Konfiguracija je odbijena',
      strategy: 'Strategija izbora',
      strategy_leastUsedResources: 'Najmanje iskorišćeni resursi',
      strategy_leastVms: 'Najmanje VM-ova',
      strategy_random: 'Nasumično',
      strategyLeastUsedResourcesHint: 'Među validnim kandidatima, čvor sa najviše preostalog upotrebljivog RAM-a (posmatrano ukupno − rezerva hosta − upaljeni VM-ovi), a nerešeno rešava vCPU zauzeće. Deterministička pri jednakim podacima.',
      strategyLeastVmsHint: 'Među validnim kandidatima, čvor sa najmanje upaljenih VM-ova; nerešeno se rešava po imenu čvora. Deterministička pri jednakim podacima.',
      strategyRandomHint: 'Uniformno nasumično među validnim kandidatima.',
      liveness: 'Prag živosti čvorova (sekunde)',
      livenessHint: 'Član koji ćuti duže od praga je nedostupan: isključen je iz raspoređivanja i — ako nije u održavanju — HA decider ga smatra mrtvim, ograđuje ga i restartuje njegove HA VM-ove drugde.',
      decider: 'HA decider',
      deciderNone: 'još nije izabran'
    },
    nodesTitle: 'Čvorovi',
    nodesSubtitle: 'Živost i empirijski kapacitet — upotrebljiv RAM = ukupno − baza − zauzeto',
    nodeCol: 'Čvor',
    stateCol: 'Stanje',
    ramCol: 'RAM (ukupno − baza − zauzeto)',
    usableCol: 'Upotrebljivo',
    vmsCol: 'Opterećenje',
    neverSeen: 'nikad viđen',
    freshChip: 'dostupan',
    staleChip: 'nedostupan',
    attestedChip: 'atestiran kao ugašen',
    ramFormula: 'ukupno − baza − zauzeto',
    haTitle: 'Visoka dostupnost',
    haSubtitle: 'VM-ovi sa HA flagom su „uvek upaljeni”: TVirt ih restartuje posle svakog zaustavljanja koje nije zatraženo — isti čvor uz backoff, drugi čvor kada njihov umre (samo deljeni storage).',
    haNone: 'Nijedan VM još nema HA flag — omogućite ga ovde ili u detaljima VM-a.',
    haVmCol: 'Virtuelna mašina',
    haStateCol: 'Stanje',
    haRestartsCol: 'HA restartovanja',
    haLastEventCol: 'Poslednji događaj',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA izmena je odbijena',
    rules: {
      title: 'Pravila afiniteta',
      createTitle: 'Novo pravilo blizine',
      editTitle: 'Izmenite pravilo',
      nameHint: 'Mala slova, cifre i crtice (DNS oznaka)',
      vms: 'Virtuelne mašine',
      vmsHint: 'Najmanje dva VM-a — pravilo vezuje gde jedni rade u odnosu na druge',
      type: 'Tip',
      affinity: 'Afinitet (zajedno)',
      antiAffinity: 'Anti-afinitet (odvojeno)',
      typeAffinityHint: 'VM-ovi treba da rade na ISTOM čvoru.',
      typeAntiAffinityHint: 'VM-ovi treba da rade na RAZLIČITIM čvorovima — klasičan HA par.',
      mode: 'Režim',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Prekršaji odbijaju operaciju (pokretanje, migracija, failover) uz rečitu grešku.',
      modeSoftHint: 'Preferencija, nikada ne blokira: raspored u prekršaju nastavlja se uz vidljivo upozorenje.',
      satisfied: 'Raspored',
      satisfiedYes: 'poštovan',
      satisfiedNo: 'prekršen',

      // Dialog standard (round #156): le violazioni hanno la loro riga, non un tooltip.
      violations: 'Prekršaji',
      noViolations: 'Nijedan'
    },
    events: {
      title: 'HA događaji',
      subtitle: 'Dnevnik dostupnosti — restartovanja, fencing, failoveri i pošteni preskoci',
      none: 'Još ništa.',
      when: 'Kada',
      kind: 'Događaj',
      target: 'Objekat',
      detail: 'Detalj',
      kindRestarted: 'HA restart',
      kindGaveUp: 'predaja (crash loop)',
      kindNodeAttested: 'čvor ograđen',
      kindFailedOver: 'failover',
      kindNoCandidate: 'nema kandidata',
      kindStorageLocalSkip: 'preskočeno (lokalni storage)',
      kindZombieFenced: 'zombi prekinut'
    }
  }
}
